import React, { useState, Component } from "react";
import useStyles from "./styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Rating from "@material-ui/lab/Rating";
import { Link } from "react-router-dom";

//Icons import
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";

// MUI Components
import {
  Button,
  Typography,
} from "@material-ui/core";

export default function AccountCard(props) {
  const classes = useStyles();
  return (
    //CAROUSEL
    <div>
      {/* DEAL PRODUCTS CARDS */}
      <Card className={classes.cardMainBox}>
        <Link to={props.link} className={classes.actionArea}>

          <CardContent style={{ paddingBottom: 1 }}>
            <Typography
              className={classes.categoryText}
              variant="body2"
              color="textSecondary"
              component="p"
              align="center"
            >
              {props.icon}
            </Typography>
            <Typography
              className={classes.titleText}
              noWrap
              gutterBottom
              variant="h6"
              component="p"
              align="center"
            >
              {props.title}
            </Typography>




          </CardContent>
        </Link>
        {/* <CardActions>
          <Button className={classes.productBtn} size="small" color="primary">
            <AddShoppingCartIcon fontSize="small" style={{ marginRight: 4 }} />
            Cart
          </Button>
          <Button className={classes.productBtn} size="small" color="primary">
            <FavoriteBorderIcon fontSize="small" style={{ marginRight: 4 }} />
            WishList
          </Button>
        </CardActions> */}
      </Card>
    </div >
  );
}
